"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var TileModuleForm_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TileModuleForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const merge_1 = __importDefault(require("lodash/merge"));
const backoffice_1 = require("../../dsl/backoffice");
const form_1 = require("../_abstract/form");
const form_2 = require("../_components/form");
const _contracts_1 = require("../_contracts");
const Tile_contracts_1 = require("./Tile.contracts");
const Tile_helpers_1 = require("./Tile.helpers");
const Tile_config_1 = require("./Tile.config");
/**
 * TODO:
 *   - Fix order of properties/methods/getters/setters.
 *   - Add missing JSDoc blocks.
 *
 * Component that contains a complete questionnaire needed to **EDIT** the `TileModule`'s contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
let TileModuleForm = TileModuleForm_1 = class TileModuleForm extends form_1.AbstractModuleForm {
    constructor() {
        super(...arguments);
        this.DashmixIconName = backoffice_1.DashmixIconName;
        /**
         * @inheritDoc
         * @override
         */
        this.initialContent = TileModuleForm_1.getInitialContent();
    }
    /**
     * @inheritDoc
     */
    get articlesCount() {
        return typeof this._version !== 'undefined'
            ? Tile_helpers_1.getArticlesCount(this.size, this._version)
            : undefined;
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialConfig() {
        return {
            driver: _contracts_1.ModuleDriver.Tile,
            size: {
                colSpan: 2,
                rowSpan: 2,
                isResizable: true,
                minColSpan: 2,
                minRowSpan: 2,
                maxColSpan: 6
            },
            version: Tile_contracts_1.TileVersion.S
        };
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialContent() {
        return {
            allowDuplicates: false,
            backgroundColor: _contracts_1.ModuleBackgroundColor.None,
            background: '',
            header: { text: '', site: '', isH1: false },
            headerLink: null,
            isPremium: false,
            list: null,
            listType: form_2.ListSelectionMode.Default,
            overrides: [],
            titleVersion: '',
            showAuthorAvatar: true,
            showAuthorName: true,
            showHeader: true,
            showPublicationDate: false,
            showTitle: true,
            showArticleTags: false,
            showCategory: true,
            startFromBeginning: false,
            titleOnImage: false,
            showModuleOnFirstPageOnly: false
        };
    }
    /**
     * Helper text for the "version" field.
     */
    get versionHelper() {
        if (typeof this._version === 'undefined') {
            return undefined;
        }
        const { colSpan, rowSpan } = this.size;
        const moduleArea = Tile_helpers_1.calculateArea(colSpan, rowSpan);
        switch (this._version) {
            case Tile_contracts_1.TileVersion.S: {
                return moduleArea < Tile_config_1.TILE_S_AREA
                    ? this.$t('forms.tile.versionHelper', Tile_config_1.tileSizeSpaceRegistry[Tile_contracts_1.TileVersion.S][Tile_contracts_1.Breakpoint.LG])
                    : undefined;
            }
            case Tile_contracts_1.TileVersion.L: {
                return moduleArea < Tile_config_1.TILE_L_AREA
                    ? this.$t('forms.tile.versionHelper', Tile_config_1.tileSizeSpaceRegistry[Tile_contracts_1.TileVersion.L][Tile_contracts_1.Breakpoint.LG])
                    : undefined;
            }
            case Tile_contracts_1.TileVersion.XL: {
                return moduleArea < Tile_config_1.TILE_XL_AREA
                    ? this.$t('forms.tile.versionHelper', Tile_config_1.tileSizeSpaceRegistry[Tile_contracts_1.TileVersion.XL][Tile_contracts_1.Breakpoint.LG])
                    : undefined;
            }
            case Tile_contracts_1.TileVersion.FourColumns:
            case Tile_contracts_1.TileVersion.FiveColumns: {
                return colSpan < 6
                    ? this.$t('forms.tile.versionHelper', { colSpan: 6, rowSpan: 1 })
                    : undefined;
            }
        }
    }
    /**
     * Options for the `<DashmixSelect name="version">`.
     */
    get versionOptions() {
        return Object.entries(Tile_contracts_1.TileVersion).map(([label, value]) => ({
            label,
            value
        }));
    }
    get titleOptions() {
        return [
            { label: `${this.$t('forms.shared.titleVersion.none')}`, value: '' },
            ...Object.values(_contracts_1.TitleVersion).map(value => ({
                label: `${this.$t('forms.shared.titleVersion.' + value)}`,
                value
            }))
        ];
    }
    get canShowCategory() {
        return this._version === Tile_contracts_1.TileVersion.XL || this._version === Tile_contracts_1.TileVersion.L;
    }
    findHeaderLinkSource(source) {
        this.describe(source);
    }
    get backgroundColorOptions() {
        return Object.values(_contracts_1.ModuleBackgroundColor)
            .map(value => ({
            label: this.$t(`modules.backgroundColors.${value}`),
            value: value
        }));
    }
    onVersionChange(newVersion) {
        switch (newVersion) {
            case Tile_contracts_1.TileVersion.S: {
                break;
            }
            case Tile_contracts_1.TileVersion.L: {
                this.$emit('changeSize', Tile_config_1.tileSizeSpaceRegistry[Tile_contracts_1.TileVersion.L][Tile_contracts_1.Breakpoint.LG]);
                break;
            }
            case Tile_contracts_1.TileVersion.XL: {
                this.$emit('changeSize', Tile_config_1.tileSizeSpaceRegistry[Tile_contracts_1.TileVersion.XL][Tile_contracts_1.Breakpoint.LG]);
                break;
            }
            case Tile_contracts_1.TileVersion.FourColumns:
            case Tile_contracts_1.TileVersion.FiveColumns: {
                this.$emit('changeSize', { colSpan: 6, rowSpan: 1 });
                break;
            }
        }
    }
    /**
     * @inheritDoc
     * @override
     */
    setInitialContent() {
        this._content = merge_1.default(this.initialContent, this._content);
    }
    setList(source) {
        this._content.list = source;
    }
};
__decorate([
    vue_property_decorator_1.Watch('version'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], TileModuleForm.prototype, "onVersionChange", null);
TileModuleForm = TileModuleForm_1 = __decorate([
    vue_property_decorator_1.Component({
        name: 'TileModuleForm',
        components: {
            DashmixButton: backoffice_1.DashmixButton,
            DashmixIcon: backoffice_1.DashmixIcon,
            DashmixInput: backoffice_1.DashmixInput,
            DashmixCheck: backoffice_1.DashmixCheck,
            DashmixSelect: backoffice_1.DashmixSelect,
            LineHeaderForm: form_2.LineHeaderForm,
            FormErrors: form_2.FormErrors,
            ListSelector: form_2.ListSelector
        },
        template: `
    <div>
      <!-- Articles count -->
      <p v-if="typeof articlesCount === 'number'"
         :class="articlesCount === 0 ? 'text-danger' : 'text-success'">
        {{ $t('forms.shared.articlesCount') }}: <b>{{ articlesCount }}</b>
      </p>

      <hr>

      <!-- Version (module variant) -->
      <div class="form-group">
        <label for="version">{{ $t('forms.shared.modulesVariant') }}</label>
        <DashmixSelect :model.sync="_version" name="version"
                       :options="versionOptions" :searchable="false" />
        <small v-if="versionHelper" v-html="versionHelper" class="text-danger" />
      </div>

      <!-- Heading -->
      <LineHeaderForm :header.sync="_content.header" :headerLink.sync="_content.headerLink"
                      :showHeader.sync="_content.showHeader"
                      :pickRelated="pickRelated"
                      :linkDescription="_content.headerLink ? description(_content.headerLink) : ''"
                      @findLinkSource="findHeaderLinkSource" />

      <div class="row">
        <!-- Alternative title -->
        <div class="form-group col-12 col-md-6">
          <label for="version">{{ $t('forms.shared.alternativeTitle') }}</label>
          <DashmixSelect :model.sync="_content.titleVersion" name="titleVersion"
                         :options="titleOptions" :searchable="false" />
        </div>

        <!-- Background color -->
        <div class="form-group col-12 col-md-6">
          <label for="color">{{ $t('forms.shared.backgroundColor') }}</label>
          <DashmixSelect :model.sync="_content.backgroundColor" name="backgroundColor"
                         :placeholder="$t('forms.shared.backgroundColorPlaceholder')"
                         :options="backgroundColorOptions" :searchable="false"/>
          <DashmixInput v-if="isCustomColor" type="color" :model.sync="_content.background" name="background"/>
        </div>
      </div>


      <!-- List (content source) -->
      <div class="form-group mb-4">
        <label for="list_value" class="d-block">
          {{ $t('forms.tile.articlesSource') }}<span class="text-danger">*</span>
        </label>

        <ListSelector :mode="mode" :list="_content.list" @update:list="setList"
                      :duplicates="_content.allowDuplicates" :listType.sync="_content.listType"
                      :pickRelated="pickRelated" :relatedService="relatedService" />

        <DashmixCheck class="pt-2" :label="$t('forms.shared.allowDuplicates')" name="allowDuplicates"
                      :model.sync="_content.allowDuplicates" />

        <DashmixCheck :label="$t('forms.shared.startFromBeginning')" name="startFromBeginning"
                      :model.sync="_content.startFromBeginning" />
      </div>

      <!-- Settings -->
      <div class="form-group">
        <!-- Show/hide author avatar -->
        <DashmixCheck :label="$t('forms.tile.options.authorAvatar')" name="showAuthorAvatar"
                      :model.sync="_content.showAuthorAvatar" />

        <!-- Show/hide author name -->
        <DashmixCheck :label="$t('forms.tile.options.authorName')" name="showAuthorName"
                      :model.sync="_content.showAuthorName" />

        <!-- Show/hide publication date -->
        <DashmixCheck :label="$t('forms.tile.options.publicationDate')" name="showPublicationDate"
                      :model.sync="_content.showPublicationDate" />

        <!-- Show/hide article's title -->
        <DashmixCheck :label="$t('forms.tile.options.title')" name="showTitle"
                      :model.sync="_content.showTitle" />

        <!-- Show article's title on top of the article's thumbnail -->
        <DashmixCheck :label="$t('forms.tile.options.image')" name="titleOnImage"
                      :model.sync="_content.titleOnImage" />

        <!-- Show article's tags -->
        <DashmixCheck :label="$t('forms.tile.options.showArticleTags')" name="showArticleTags"
                      :model.sync="_content.showArticleTags" />

        <!-- Show category tags -->
        <DashmixCheck v-if="canShowCategory" :label="$t('forms.tile.options.showCategory')" name="showCategory"
                      :model.sync="_content.showCategory" />

        <DashmixCheck :label="$t('forms.tile.options.showModuleOnFirstPageOnly')" name="showModuleOnFirstPageOnly"
                      :model.sync="_content.showModuleOnFirstPageOnly"/>
      </div>
      <!-- END | Settings -->

      <!-- Form errors -->
      <FormErrors v-if="errors" v-bind="{ errors }" class="mt-3" />
    </div>
  `
    })
], TileModuleForm);
exports.TileModuleForm = TileModuleForm;
//# sourceMappingURL=Tile.form.js.map